"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var set_1 = __importDefault(require("lodash/set"));
function convertFastestErrorsToFormik(check, values) {
    var errors = {};
    try {
        var valRes = check(values);
        errors = Array.isArray(valRes) ? valRes.reduce(function (a, e) { return set_1.default(a, e.field, e.message); }, {}) : {};
    }
    catch (e) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Validation call error', e);
        }
    }
    return errors;
}
exports.default = convertFastestErrorsToFormik;
//# sourceMappingURL=convertFastestErrorsToFormik.js.map